export enum CustomerDetailsPlacement {
  Chats = "Chats",
  Customers = "Customers",
  Archives = "Archives",
  Tickets = "Tickets",
}

export enum CustomerDetailsDefaultSectionEnum {
  GeneralInfo = "generalInfo",
  Tickets = "tickets",
  IntegrationsData = "integrationsData",
  Facebook = "facebook",
  Prechat = "prechat",
  Postchat = "postchat",
  VisitedPages = "visitedPages",
  AdditionalInfo = "additionalInfo",
  Technology = "technology",
}

export enum CustomerDetailsDefaultSectionTitleEnum {
  GeneralInfo = "General info",
  Tickets = "Tickets",
  IntegrationsData = "Integrations data",
  Facebook = "Facebook",
  Prechat = "Pre-chat survey",
  Postchat = "Post-chat survey",
  VisitedPages = "Visited pages",
  AdditionalInfo = "Additional info",
  Technology = "Technology",
}

export const CUSTOMER_DETAILS_DEFAULT_SECTIONS: string[] = Object.keys(CustomerDetailsDefaultSectionEnum).map(
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  key => CustomerDetailsDefaultSectionEnum[key]
);

export const CUSTOMER_DETAILS_DEFAULT_COLUMNS = Object.keys(CustomerDetailsDefaultSectionEnum).map(key => ({
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  field: CustomerDetailsDefaultSectionEnum[key],
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  title: CustomerDetailsDefaultSectionTitleEnum[key],
}));

export const CUSTOMER_DETAILS_WIDGET_ID = "customer_details";
